export default __webpack_public_path__ + "static/media/measureUpMale.16938a50.png";